import * as React from 'react';

import redirect from 'js/lib/coursera.redirect';

import type SubscriptionsV1 from 'bundles/naptimejs/resources/subscriptions.v1';
import CancelSubscriptionModal from 'bundles/subscriptions-common/components/CancelSubscriptionModal';

type InputProps = {
  onClose: () => void;
};

type Props = InputProps & {
  subscription: SubscriptionsV1;
};

const CancelSubscriptionModalWithData = (props: Props) => {
  const { onClose } = props;
  const handleClose = (didSuccessfullyCancel?: boolean): void => {
    onClose();

    // reload the page to update the UI after processing cancellation
    if (didSuccessfullyCancel) {
      redirect.refresh();
    }
  };
  return <CancelSubscriptionModal {...props} onClose={handleClose} />;
};

export default CancelSubscriptionModalWithData;
